export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DeclarerInfo.vue?vue&type=template&id=b826bd1a"


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/sts/declarers/declarer/DeclarerInfo.vue?vue&type=template&id=b826bd1a
// module id = 1077
// module chunks = 11